import React from "react";
import styled from "styled-components";
import { position, PositionProps, layout, LayoutProps } from "styled-system";
import { Box, Card } from "@bca/ui-library";

const BackgroundMasker = styled.div<
  PositionProps & LayoutProps & { css?: string }
>`
  background: #fff;
  position: absolute;
  z-index: 1;
  ${position}
  ${layout}
  ${(props) => props.css}
`;

const PlaceholderCard = styled(Card)<LayoutProps>`
  ${layout}
`;

const SalesCardLoadingPlaceholder = () => {
  return (
    <Box
      maxWidth={["calc(100% - 32px)", "calc(100% - 48px)", 976]}
      margin="0 auto"
    >
      <PlaceholderCard
        height="205px"
        minHeight={["330px", "261px", "205px"]}
        width="100%"
        marginX={0}
        css={`
          @keyframes loading {
            100% {
              transform: translateX(120%);
            }
          }
          height: 220px;
          position: relative;
          background-color: rgba(126, 154, 179, 0.1);
          &:after {
            content: "";
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              to right,
              rgba(0, 0, 0, 0),
              rgba(126, 154, 179, 0.2),
              rgba(0, 0, 0, 0)
            );
            transform: translateX(-120%);
            animation: 2s loading ease-in-out infinite;
          }
        `}
        data-testid="placeholder-card"
      >
        <BackgroundMasker
          left={0}
          top={0}
          css={`
            width: 100%;
            height: 40px;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          left={0}
          bottom={0}
          css={`
            width: 100%;
            height: 40px;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          right={0}
          top="40px"
          css={`
            width: calc(100% - 236px);
            height: 20px;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          left={0}
          top={0}
          css={`
            width: 36px;
            height: 100%;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          left={0}
          top="60px"
          css={`
            width: 100%;
            height: 20px;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          right={0}
          top={0}
          css={`
            width: 36px;
            height: 100%;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          right={0}
          top={0}
          css={`
            width: 36px;
            height: 100%;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          left={0}
          top={100}
          css={`
            width: 100%;
            height: 20px;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          left={150}
          top={120}
          css={`
            width: 20px;
            height: 20px;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          left={300}
          top={120}
          css={`
            width: calc(100% - 300px);
            height: 20px;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          left={100}
          top={80}
          css={`
            width: 12px;
            height: 20px;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          left={377}
          top={80}
          css={`
            width: calc(100% - 377px);
            height: 20px;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          left={0}
          top={140}
          width={["100%", "100%", "calc(100% - 286px)"]}
          height="20px"
        ></BackgroundMasker>
        <BackgroundMasker
          left={140}
          top={160}
          css={`
            width: 36px;
            height: 20px;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          left={60}
          top={160}
          css={`
            width: 12px;
            height: 20px;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          left={200}
          top={160}
          css={`
            width: 12px;
            height: 20px;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          left={290}
          top={160}
          width={["calc(100% - 576px)", "calc(100% - 326px)", "36px"]}
          height="20px"
        ></BackgroundMasker>
        <BackgroundMasker
          left={350}
          top={160}
          css={`
            width: 12px;
            height: 20px;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          left={430}
          top={160}
          css={`
            width: calc(100% - 716px);
            height: 20px;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          right={[36, 72]}
          top={140}
          width={["calc(100% - 312px)", "18px"]}
          height="40px"
        ></BackgroundMasker>
        <BackgroundMasker
          right={76}
          top={180}
          width={[0, "18px", 0]}
          height={[0, "20px", 0]}
        ></BackgroundMasker>
        <BackgroundMasker
          left={0}
          top={180}
          width={["100%", "calc(100% - 218px)", "calc(100% - 76px)"]}
          height="20px"
        ></BackgroundMasker>
        <BackgroundMasker
          left={60}
          top={200}
          css={`
            width: 12px;
            height: 20px;
          `}
        ></BackgroundMasker>
        <BackgroundMasker
          left={140}
          top={200}
          width={["calc(100% - 176px)", "calc(100% - 358px)", 0]}
          height={["20px", "20px", 0]}
        ></BackgroundMasker>
        <BackgroundMasker
          right={76}
          top={200}
          width={["calc(100% - 716px)", "18px", "100%"]}
          height={"20px"}
        ></BackgroundMasker>
        <BackgroundMasker
          left={0}
          top={220}
          width={["100%", 0, 0]}
          height="28px"
        ></BackgroundMasker>
        <BackgroundMasker
          right={76}
          top={248}
          width={["18px", 0, 0]}
          height="40px"
        ></BackgroundMasker>
      </PlaceholderCard>
    </Box>
  );
};

export default SalesCardLoadingPlaceholder;
